import { ICellRendererParams } from 'ag-grid-community'

const accessCodeStatusRenderer = (
  props: ICellRendererParams<{
    status: string
  }>,
) => {
  const { status } = props?.data || {}

  const value = status

  return value
}

export default accessCodeStatusRenderer
